/**
 * Hyphenation controller.
 *
 * This class controls the hyphenation of long words with JS.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class Hyphenation {

    /**
     * Cache dom elements for use in class methods
     */
    cache() {

        this.HyphenationTargets = [
            '.hyphenate',
            '.hyphenate-content h2',
            '.hyphenate-content h3',
            '.hyphenate-content h4'
        ];

        // You need to add each language here.
        const docLang = $( 'html' ).attr( 'lang' );
        const languages = {
            'en-GB': 'en-gb',
            'fi': 'fi',
            'sv-SE': 'sv'
        };

        this.convertedLangCode = languages[ docLang ];
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        $.each( this.HyphenationTargets, ( index, identifier ) => {
            $( identifier ).hyphenate( this.convertedLangCode );
        });
    }

    /**
     * Run when the document is ready.
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/hyphenation.js